import React from "react";
import { CheckCircle, Mail, Heart } from "lucide-react";

const ConfirmationPage = () => {
  return (
    <section className="tt-confirmation-page">
      <div className="tt-confirmation-card">
        <CheckCircle size={48} className="tt-confirmation-icon-success" />
        <h1 className="tt-confirmation-title">Thank You!</h1>

        <p className="tt-confirmation-message">
          Your request for a session has been successfully received. We truly appreciate the trust you are placing in <strong>The Tiny Therapist</strong>.
        </p>

        <p className="tt-confirmation-message">
          <Mail size={18} className="tt-confirmation-icon-inline" /> You will receive a confirmation email shortly to check and discuss the concerns or topics you’d like to focus on.
        </p>

        <p className="tt-confirmation-message">
          <Heart size={18} className="tt-confirmation-icon-inline" /> We look forward to connecting with you and supporting you on your journey toward mental well-being.
        </p>

        <p className="tt-confirmation-signature">Regards,<br />Rutika Khandol</p>
      </div>
    </section>
  );
};

export default ConfirmationPage;
